import * as RadixPopover from '@radix-ui/react-popover'
import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import {
  environmentAtom,
  showDebugScreenAtom,
  showDemoScreenAtom,
} from '@root/shared'
import { DebugJson, type DialogControlProps } from '@root/shared/ui-kit'

type DevStatusDialogProps = {
  children: React.ReactElement
} & DialogControlProps

export const DevStatusDialog: React.FC<DevStatusDialogProps> = ({
  children,
  onOpenChange,
  open,
}) => {
  const [env] = useAtom(environmentAtom)
  const [_showDebugScreen, setShowDebugScreen] = useAtom(showDebugScreenAtom)
  const [_showDemoScreen, setShowDemoScreen] = useAtom(showDemoScreenAtom)

  const handleOpenDebugScreen = () => {
    setShowDebugScreen(true)
  }
  const handleOpenDemoScreen = () => {
    setShowDemoScreen(true)
  }

  return (
    <RadixPopover.Root open={open} onOpenChange={onOpenChange}>
      <RadixPopover.Trigger asChild>{children}</RadixPopover.Trigger>
      <RadixPopover.Portal>
        <Content side="top" align="start" sideOffset={10}>
          <Toolbar>
            <Button
              size="xxs"
              onClick={handleOpenDebugScreen}
              radius="rounded"
              variant="ghost"
            >
              Open Debug Screen
            </Button>
            <Button
              size="xxs"
              onClick={handleOpenDemoScreen}
              radius="rounded"
              variant="ghost"
            >
              Open Demo Mode
            </Button>
          </Toolbar>
          <DebugJson value={env} />
        </Content>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  )
}

const Content = styled(RadixPopover.Content)`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);

  max-width: 600px;
  max-height: 336px;
  overflow: auto;
  border: 1px solid var(--background-3);
  background: var(--background-1);
  box-shadow: 0 -10px 60px 0 rgba(0, 0, 0, 0.84);

  gap: 8px;
`

const Toolbar = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  place-content: start;
  gap: 8px;
  padding: 10px;
`
